module.exports = __webpack_public_path__ + "sw.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/sw-loader!./src/sw.js
// module id = RHAn
// module chunks = 1